import { defineMessages } from 'react-intl';

export default defineMessages({
  graphLegendTitle: 'Historical rates',

  apy: 'APY',
  variable: 'Variable',
  stable: 'Stable',
});
